import apiUrls from '../urls';

export default function (api) {
    return {
        getBanners() {
            return api.get(apiUrls.BANNERS);
        },
    }
};